import { useAuth0 } from "@auth0/auth0-react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import AuthService from "Lib/API/Auth";
import { ReactComponent as Download } from "assets/icons/Download.svg";
import deleteImg from "assets/icons/Trush.svg";
import { formatDate } from "helper/dateFormat";
import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { BatchDocumentActions, DocumentLink, DownloadButton } from './Theme';
import { fontConfig } from "theme/fontConfig";

const TableCellBody = withStyles((theme) => ({
    root: {
      fontFamily: fontConfig.GeneralTableCellBodyFont.family,
      fontSize: "14px",
      color: "#4d5565"
    },
  }))(TableCell);

const BatchDocumentsTableData = ({ row,deleteBatchDocumentHandler }) => {
    const { getAccessTokenSilently } = useAuth0();
    const history = useHistory();

    const handleDownload = async () => {
        const token = await getAccessTokenSilently();
        await AuthService.downloadBatchDocuments(row?.file, token).then((res) => {
            // to download the pdf from api url
            const link = document.createElement("a");
            link.href = res?.generatedDownloadLink;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }



    return (
        <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCellBody component="th" scope="row">
                    {row?.totalDocument > 0 && row?.status === 'completed' ? (
                        <DocumentLink className="bulk-document-link"
                            onClick={() => {
                                history.push({
                                    pathname: `/finance/documents`,
                                    state: { 
                                        documentId: row?._id,
                                        documentType: row?.type
                                    }
                                })
                            }}
                        >
                            {row?.name}
                        </DocumentLink>
                    ) : 
                        row?.name
                    }
                </TableCellBody>
                <TableCellBody align="left">{row?.totalDocument}</TableCellBody>
                <TableCellBody align="left">{row?.status === "inProgress" ? 'In Preparation' : 'Completed'}</TableCellBody>
                <TableCellBody align="left">{row?.type === 'tax_report' ? 'Tax Report' : 'Statement'}</TableCellBody>
                <TableCellBody align="left">{row?.created_by?.name} - {formatDate({date:row?.createdAt, formatType: "defaultWithUTC"})}</TableCellBody>
                <TableCellBody className="sticky-body-column" align="left">
                    {row?.status === 'completed' && row?.totalDocument !== 0 &&
                        <BatchDocumentActions>
                            <DownloadButton onClick={() => {
                                deleteBatchDocumentHandler(row);
                            }}>
                                <img src={deleteImg} alt="trush" width={26} />
                            </DownloadButton>
                            <DownloadButton onClick={handleDownload} disabled={!row?.file}>
                                <Download />
                            </DownloadButton>
                        </BatchDocumentActions>
                    }
                </TableCellBody>

            </TableRow>
        </React.Fragment>
    );
};
export default memo(BatchDocumentsTableData);
